import axios from "axios";
import { __constants } from "../../constants";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

/* HouseKeeper Management */
export const getHouseKeeperAvailableForController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/house-keeper-availablefor",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getHouseKeeperAvailableForController >> ", err.message);
        return err.response
    }
}

export const addHouseKeeperAvailableForController = async (name,file,greyImage) => {
    try {
        var formdata = new FormData();
        formdata.append("name", name);
        formdata.append("file", file);
        formdata.append("greyImage", greyImage);        
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/add-house-keeper-availablefor",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: formdata
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addHouseKeeperAvailableForController >> ", err.message);
        return err.response
    }
}

export const getHouseKeeperHappyWithController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/house-keeper-interesetedfor",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getHouseKeeperHappyWithController >> ", err.message);
        return err.response
    }
}

export const getHouseKeeperIHaveMyOwnController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/house-keeper-ihavemyown",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getHouseKeeperHappyWithController >> ", err.message);
        return err.response
    }
}

export const addHouseKeeperHappyWithController  = async (name, file,greyImage) => {
    try {
        var formdata = new FormData();
        formdata.append("name", name);
        formdata.append("file", file);
        formdata.append("greyImage", greyImage);
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/add-house-keeper-interesetedfor",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: formdata
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addHouseKeeperHappyWithController >> ", err.message);
        return err.response
    }
}

export const addHouseKeeperIHaveMyOwnController  = async (name, file,greyImage) => {
    try {
        var formdata = new FormData();
        formdata.append("name", name);
        formdata.append("file", file);
        formdata.append("greyImage", greyImage);
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/add-house-keeper-ihavemyown",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: formdata
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addHouseKeeperHappyWithController >> ", err.message);
        return err.response
    }
}

export const getHouseKeeperExperienceController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/housekeeper-experience",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getHouseKeeperExperienceController >> ", err.message);
        return err.response
    }
}

export const deleteData = async (id) => {
    try {
        const config = {
            method: 'DELETE',
            url: BASE_URL + `/v1/admin/preuser-detail/${id}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in deleteData >> ", err.message);
        return err.response
    }
}


/* HouseKeeper booking options (optionType: "cleaning-type" | "add-on") */
export const getHouseKeeperBookingOptionsController = async (optionType) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/house-keeper-booking-option/${optionType}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getHouseKeeperBookingOptionsController >> ", err.message);
        return err.response
    }
}

export const addHouseKeeperBookingOptionController = async (optionType, name, description) => {
    try {
        const config = {
            method: 'POST',
            url: BASE_URL + `/v1/admin/house-keeper-booking-option/${optionType}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: { name, description }
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addHouseKeeperBookingOptionController >> ", err.message);
        return err.response
    }
}

export const editHouseKeeperBookingOptionController = async (id, name, description) => {
    try {
        const formdata = new FormData();
        formdata.append("id", id);
        formdata.append("name", name);
        formdata.append("description", description);
        const config = {
            method: 'PUT',
            url: BASE_URL + "/v1/admin/preuser-info",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: formdata
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in editHouseKeeperBookingOptionController >> ", err.message);
        return err.response
    }
}
